var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntlogyHomeGridIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    zoomAndPan: "magnify",
    viewBox: "0 0 600 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "df5b9af166"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.777344 202.523438 L 86.042969 202.523438 L 86.042969 353.300781 L 29.777344 353.300781 Z M 29.777344 202.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "91faa8ef03"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.277344 202.523438 L 63.542969 202.523438 C 69.511719 202.523438 75.234375 204.890625 79.453125 209.113281 C 83.675781 213.332031 86.042969 219.054688 86.042969 225.023438 L 86.042969 330.765625 C 86.042969 336.734375 83.675781 342.457031 79.453125 346.675781 C 75.234375 350.894531 69.511719 353.265625 63.542969 353.265625 L 52.277344 353.265625 C 46.308594 353.265625 40.585938 350.894531 36.367188 346.675781 C 32.148438 342.457031 29.777344 336.734375 29.777344 330.765625 L 29.777344 225.023438 C 29.777344 219.054688 32.148438 213.332031 36.367188 209.113281 C 40.585938 204.890625 46.308594 202.523438 52.277344 202.523438 Z M 52.277344 202.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7ceb0d4022"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.777344 0.523438 L 57.042969 0.523438 L 57.042969 151.28125 L 0.777344 151.28125 Z M 0.777344 0.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f7dec09573"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.277344 0.523438 L 34.542969 0.523438 C 40.511719 0.523438 46.234375 2.890625 50.453125 7.113281 C 54.675781 11.332031 57.042969 17.054688 57.042969 23.023438 L 57.042969 128.765625 C 57.042969 134.734375 54.675781 140.457031 50.453125 144.675781 C 46.234375 148.894531 40.511719 151.265625 34.542969 151.265625 L 23.277344 151.265625 C 17.308594 151.265625 11.585938 148.894531 7.367188 144.675781 C 3.148438 140.457031 0.777344 134.734375 0.777344 128.765625 L 0.777344 23.023438 C 0.777344 17.054688 3.148438 11.332031 7.367188 7.113281 C 11.585938 2.890625 17.308594 0.523438 23.277344 0.523438 Z M 23.277344 0.523438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c79f3fd050"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 58,
    y: 0,
    height: 152
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3efb4ddb3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 201.605469 21.734375 L 570.695312 21.734375 L 570.695312 353.265625 L 201.605469 353.265625 Z M 201.605469 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "54561f7a1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 224.105469 21.734375 L 547.722656 21.734375 C 553.691406 21.734375 559.414062 24.105469 563.632812 28.324219 C 567.851562 32.542969 570.222656 38.265625 570.222656 44.234375 L 570.222656 330.765625 C 570.222656 336.734375 567.851562 342.457031 563.632812 346.675781 C 559.414062 350.894531 553.691406 353.265625 547.722656 353.265625 L 224.105469 353.265625 C 218.136719 353.265625 212.414062 350.894531 208.195312 346.675781 C 203.976562 342.457031 201.605469 336.734375 201.605469 330.765625 L 201.605469 44.234375 C 201.605469 38.265625 203.976562 32.542969 208.195312 28.324219 C 212.414062 24.105469 218.136719 21.734375 224.105469 21.734375 Z M 224.105469 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "571a6e4902"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.605469 0.734375 L 369.238281 0.734375 L 369.238281 332.265625 L 0.605469 332.265625 Z M 0.605469 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6ef17e90ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.105469 0.734375 L 346.722656 0.734375 C 352.691406 0.734375 358.414062 3.105469 362.632812 7.324219 C 366.851562 11.542969 369.222656 17.265625 369.222656 23.234375 L 369.222656 309.765625 C 369.222656 315.734375 366.851562 321.457031 362.632812 325.675781 C 358.414062 329.894531 352.691406 332.265625 346.722656 332.265625 L 23.105469 332.265625 C 17.136719 332.265625 11.414062 329.894531 7.195312 325.675781 C 2.976562 321.457031 0.605469 315.734375 0.605469 309.765625 L 0.605469 23.234375 C 0.605469 17.265625 2.976562 11.542969 7.195312 7.324219 C 11.414062 3.105469 17.136719 0.734375 23.105469 0.734375 Z M 23.105469 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a13daada2b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 370,
    y: 0,
    height: 333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "66c8be7da0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115.734375 21.734375 L 171.914062 21.734375 L 171.914062 353.3125 L 115.734375 353.3125 Z M 115.734375 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c60a4ab75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.234375 21.734375 L 149.414062 21.734375 C 155.382812 21.734375 161.105469 24.105469 165.324219 28.324219 C 169.542969 32.542969 171.914062 38.265625 171.914062 44.234375 L 171.914062 330.765625 C 171.914062 336.734375 169.542969 342.457031 165.324219 346.675781 C 161.105469 350.894531 155.382812 353.265625 149.414062 353.265625 L 138.234375 353.265625 C 132.269531 353.265625 126.546875 350.894531 122.328125 346.675781 C 118.105469 342.457031 115.734375 336.734375 115.734375 330.765625 L 115.734375 44.234375 C 115.734375 38.265625 118.105469 32.542969 122.328125 28.324219 C 126.546875 24.105469 132.269531 21.734375 138.234375 21.734375 Z M 138.234375 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68358de543"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.734375 0.734375 L 56.914062 0.734375 L 56.914062 332.28125 L 0.734375 332.28125 Z M 0.734375 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7e20ae8b23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.234375 0.734375 L 34.414062 0.734375 C 40.382812 0.734375 46.105469 3.105469 50.324219 7.324219 C 54.542969 11.542969 56.914062 17.265625 56.914062 23.234375 L 56.914062 309.765625 C 56.914062 315.734375 54.542969 321.457031 50.324219 325.675781 C 46.105469 329.894531 40.382812 332.265625 34.414062 332.265625 L 23.234375 332.265625 C 17.269531 332.265625 11.546875 329.894531 7.328125 325.675781 C 3.105469 321.457031 0.734375 315.734375 0.734375 309.765625 L 0.734375 23.234375 C 0.734375 17.265625 3.105469 11.542969 7.328125 7.324219 C 11.546875 3.105469 17.269531 0.734375 23.234375 0.734375 Z M 23.234375 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd436a1df3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 57,
    y: 0,
    height: 333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8188f7b753"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.777344 21.734375 L 86.042969 21.734375 L 86.042969 172.515625 L 29.777344 172.515625 Z M 29.777344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2a9380f5e5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.277344 21.734375 L 63.542969 21.734375 C 69.511719 21.734375 75.234375 24.105469 79.453125 28.324219 C 83.675781 32.542969 86.042969 38.265625 86.042969 44.234375 L 86.042969 149.976562 C 86.042969 155.945312 83.675781 161.667969 79.453125 165.886719 C 75.234375 170.109375 69.511719 172.476562 63.542969 172.476562 L 52.277344 172.476562 C 46.308594 172.476562 40.585938 170.109375 36.367188 165.886719 C 32.148438 161.667969 29.777344 155.945312 29.777344 149.976562 L 29.777344 44.234375 C 29.777344 38.265625 32.148438 32.542969 36.367188 28.324219 C 40.585938 24.105469 46.308594 21.734375 52.277344 21.734375 Z M 52.277344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c2cc572888"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.777344 0.734375 L 57.042969 0.734375 L 57.042969 151.515625 L 0.777344 151.515625 Z M 0.777344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c77f2e139f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.277344 0.734375 L 34.542969 0.734375 C 40.511719 0.734375 46.234375 3.105469 50.453125 7.324219 C 54.675781 11.542969 57.042969 17.265625 57.042969 23.234375 L 57.042969 128.976562 C 57.042969 134.945312 54.675781 140.667969 50.453125 144.886719 C 46.234375 149.109375 40.511719 151.476562 34.542969 151.476562 L 23.277344 151.476562 C 17.308594 151.476562 11.585938 149.109375 7.367188 144.886719 C 3.148438 140.667969 0.777344 134.945312 0.777344 128.976562 L 0.777344 23.234375 C 0.777344 17.265625 3.148438 11.542969 7.367188 7.324219 C 11.585938 3.105469 17.308594 0.734375 23.277344 0.734375 Z M 23.277344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbaf6bdf0a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 58,
    y: 0,
    height: 152
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#df5b9af166)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#91faa8ef03)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 29, 202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c79f3fd050)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7ceb0d4022)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f7dec09573)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.777344 0.523438 L 57.042969 0.523438 L 57.042969 151.300781 L 0.777344 151.300781 Z M 0.777344 0.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3efb4ddb3d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#54561f7a1a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 201, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a13daada2b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#571a6e4902)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6ef17e90ca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.605469 0.734375 L 369.695312 0.734375 L 369.695312 332.265625 L 0.605469 332.265625 Z M 0.605469 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#66c8be7da0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c60a4ab75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 115, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd436a1df3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68358de543)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e20ae8b23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.734375 0.734375 L 56.914062 0.734375 L 56.914062 332.3125 L 0.734375 332.3125 Z M 0.734375 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8188f7b753)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a9380f5e5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 29, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bbaf6bdf0a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c2cc572888)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c77f2e139f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.777344 0.734375 L 57.042969 0.734375 L 57.042969 151.515625 L 0.777344 151.515625 Z M 0.777344 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntlogyHomeGridIcon3);
export default __webpack_public_path__ + "static/media/antlogyHomeGridIcon3.29e0cc2c0f8f5a6d22144330e2b33905.svg";
export { ForwardRef as ReactComponent };